import { CgpConfirmationDialogService } from '../cgp-confirmation-dialog/cgp-confirmation-dialog.service';
import { CgpSnackbarService } from '../cgp-snackbar/cgp-snackbar.service';
import { CgpAlertDialogService } from '../cgp-alert-dialog/cgp-alert-dialog.service';
import {
    Component,
    Input,
    Output,
    EventEmitter,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { State, process } from '@progress/kendo-data-query';
import { MescService } from '../../components/mesc/mesc.service';
import { GridDataResult } from '@progress/kendo-angular-grid';
import { Observable, of, BehaviorSubject } from 'rxjs';
import { ExcelExportData } from '@progress/kendo-angular-excel-export';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'cgp-grid',
    templateUrl: './cgp-grid.component.html',
    styleUrls: ['./cgp-grid.component.scss'],
    host: { 'class': 'inline-flex' },
})


export class CgpGridComponent {
    @Input() template: any;
    @Input() hasDetailTemplate: boolean;
    @Input() editDataItem: any;
    @Input() formDialog: any;
    @Input() editForm: FormGroup;
    @Input() system: any;
    @Input() toolTypeId: number;
    @Input() id: string;
    @Input() parentId: any;
    @Input() detailEditDataItem: any;

    @Input()
    private set state(state: State) {
        if (state) this.gridState = state;
    }
    @Input()
    private set filterDataItem(obj: any) { }


    @Output() setModel: EventEmitter<any> = new EventEmitter();
    @Output() read: EventEmitter<any> = new EventEmitter();
    @Output() edit: EventEmitter<any> = new EventEmitter();
    @Output() onDetailEvent: EventEmitter<any> = new EventEmitter();

    isDetailRow: boolean = false;
    gridView: any;
    editService: MescService;
    view: Observable<GridDataResult>;
    isNew: boolean;
    selectedRows: any[] = [];
    data: any[];
    Id: string; // Used with grid select
    isSelectAll: boolean;
    fullDataSet: any[] = [];

    gridState: State = {
        sort: [],
        skip: 0,
        take: 10,
        group: []
    };

    selectableSettings: any = {
        enabled: true,
        checkboxOnly: true,
        mode: "multiple",
    }
    editedRowIndex: number;

    constructor(
        private cgpConfirmationDialogService: CgpConfirmationDialogService,
        private cgpSnackbarService: CgpSnackbarService,
        private cgpAlertDialogService: CgpAlertDialogService,
        private datePipe: DatePipe,
    ) { }


    ngOnInit(): void {
        if (this.template.state) this.gridState = this.template.state;
        this.editService = this.template.service;
        this.gridView = this.template.view ? this.template.view : this.template.service;

        if (!this.template.read) {
            (this.gridView as BehaviorSubject<any>)
                .subscribe(data => {
                    const gridResult = process(data, this.gridState);
                    this.data = gridResult.data;
                    this.view = of(gridResult);
                });
        }

        this.refresh();
    }


    onStateChange(state: State) {
        this.gridState = state;
        this.refresh();
    }


    ngOnChanges() {
        if (this.view && !this.editDataItem) this.refresh();
    }

    resetState() {
        this.gridState.skip = 0;
    }

    closeDialog() {
        this.editDataItem = undefined;
    }


    refresh(forceRefresh: boolean = false) {
        if (forceRefresh) {
            this.selectedRows = [];
            this.isSelectAll = false;
        }

        if (this.template.method) {
            switch (this.template.method) {
                case 'getById':
                    if (this.editDataItem && this.editDataItem.Id)
                        this.gridView.getById(this.editDataItem.Id);
                    else if (this.id) {
                        this.gridView.getById(this.id);
                    }
                    break;
                case 'getToolsForSystemByToolType':
                    if (this.system)
                        this.gridView.getToolsForSystemByToolType(this.system.Id, this.toolTypeId)
                    break;
                case 'getToolsByParentId':
                    if (this.parentId)
                        this.gridView.getToolsByParentId(this.parentId);
                    break;
                case 'custom':
                    this.read.emit();
                    break;
                default:
                    break;
            }
        }
        else if (this.template.read) {
            let dataItem = this.detailEditDataItem ? this.detailEditDataItem : this.editDataItem
            let response = this.template.read(forceRefresh, dataItem, this.gridState);
            if (response) {
                response.then(response => {
                    if (!response) { response = []; }
                    this.fullDataSet = (response.data) ? response.data : response;
                    const isDataResult = response.hasOwnProperty('total');
                    const dataResult = isDataResult ? response : process(response, this.gridState);
                    this.data = dataResult.data;
                    this.view = of(dataResult);
                }).catch(e => {
                    this.cgpAlertDialogService.showAlertDialog({
                        title: 'Error Refreshing Datasource',
                        message: e._body ? e._body.replace(/"/g, '') : '',
                        alert: 'danger',
                        closeLabel: 'Close',
                    })
                })
            }
        }
        else {
            this.gridView.query();
        }
    }


    closeEditor(grid: any, rowIndex = this.editedRowIndex) {
        grid.closeRow(rowIndex);
        this.editedRowIndex = undefined;
        this.setModel.emit();
    }


    cancelHandler(obj: any) {
        this.editDataItem = undefined;
        if (obj) this.closeEditor(obj.sender, obj.rowIndex)
        this.isDetailRow = false;
    }


    addHandler({ sender, dataItem }) {
        if (this.template.isDetail) {
            this.onDetailEvent.emit({ sender: sender, dataItem: this.detailEditDataItem });
            return;
        }

        this.setModel.emit(dataItem);
        this.isNew = true;
        if (!this.formDialog) {
            this.closeEditor(sender);
            sender.addRow(this.editForm);
        }
        this.isDetailRow = false;
    }


    handleDetailRowEvent(props) {
        this.isDetailRow = true;
        if (props.rowIndex !== undefined) {
            this.editHandler(props);
        } else if (props.sender) {
            this.addHandler(props);
        } else {
            this.removeHandler(props);
        }
    }

    editHandler({ sender, rowIndex, dataItem }) {
        if (this.template.isDetail) {
            this.onDetailEvent.emit({ sender, rowIndex, dataItem });
            return;
        }
        this.editDataItem = dataItem;
        this.isNew = false;
        if (this.edit && this.edit.observers.length > 0) {
            this.edit.emit({ dataItem, isDetailRow: this.isDetailRow });
        } else if (this.template.edit) {
            this.template.edit(dataItem, this.isDetailRow);
        }


        if (!this.formDialog && this.editForm) {
            this.closeEditor(sender);
            this.editForm.reset(dataItem);
            this.editedRowIndex = rowIndex;
            sender.editRow(rowIndex, this.editForm);
        }
        this.isDetailRow = false;
    }


    onSave({ sender, rowIndex, formGroup }) {
        this.saveHandler(formGroup.value)
        sender.closeRow(rowIndex);
    }


    saveHandler(dataItem) {
        let response: Promise<any>;
        if (this.template.save) {
            response = this.template.save(dataItem, this.isNew, this.isDetailRow);
        } else {
            response = this.editService.save(dataItem, this.isNew);
        }

        this.handleResponse(response, this.isNew ? 'Record has been created' : 'Record has been updated');

        this.editDataItem = undefined;
        this.isDetailRow = false;
    }


    removeHandler({ dataItem }) {
        console.log('here :)')
        if (this.template.isDetail) {
            this.onDetailEvent.emit({ dataItem });
            return;
        }

        var message: string = this.template.displayField ? "Are you sure that you want to delete " + dataItem[this.template.displayField] + '?' : 'Are you sure that you want to delete this record?'

        let self = this;
        this.cgpConfirmationDialogService.showConfirmationDialog({
            title: 'Delete Confirmation',
            message: message,
            alert: 'danger',
            onYesClick: () => {
                let response = self.template.delete ?
                    self.template.delete(dataItem) :
                    self.editService.remove('/' + dataItem.Id, false)

                let data: any = self.view['source'];
                if (data) data = data.data;
                if (data && data.length - 1 <= self.gridState.skip)
                    self.gridState.skip = 0;

                self.handleResponse(response, 'Record has been deleted');
                self.cgpConfirmationDialogService.closeConfirmationDialog();
            },
            onNoClick: () => {
                self.cgpConfirmationDialogService.closeConfirmationDialog();
            }
        });
    }


    handleResponse(response: Promise<any>, messageText: string) {
        if (!response) return;
        response.then(() => {
            this.refresh(true);
            this.cgpSnackbarService.showSnackbar({
                message: messageText,
                duration: 2000
            });
        }).catch(x => {
            this.refresh(true);
            let errorMessage;
            if(x.error?.ExceptionMessage){
                errorMessage = x.error.ExceptionMessage
            } else{
                errorMessage = x._body ? x._body.replace(/"/g, '') : '';
            }
            this.cgpAlertDialogService.showAlertDialog({
                title: 'Error',
                message: errorMessage,
                alert: 'danger',
                closeLabel: 'Close',
            })
        });
    }


    handleToolBarButtonClick = (event, button) => {
        button.callback(this.detailEditDataItem, this.editService, this.system, button.callbackInputs)
        if (button.refresh) this.refresh(true);
    }


    handleCommandButtonClick = (event, button, dataItem) => {
        button.callback(event, dataItem, this.editService, this.system, button.callbackInputs)
        if (button.refresh) this.refresh(true);
    }


    saveFilterHandler() {
        this.refresh(true);
    }



    public get IsSelectAllDisabled(): boolean {
        return !(this.template.selectable && this.data && this.data.length > 0);
    }

    onSelectionChange = (e) => {

        // Add selected rows
        e.selectedRows.forEach(r => {
            const index = this.selectedRows.indexOf(r);
            if (index === -1) {
                this.selectedRows.push(r);
            }
        });

        // Remove selected rows
        e.deselectedRows.forEach(r => {
            const index = this.selectedRows.findIndex(s => s.index === r.index);
            if (index !== -1) {
                this.selectedRows.splice(index, 1);
            }
        });

        this.template.select(this.selectedRows);
    }

    isRowSelected = (e) => {
        return this.selectedRows.some(x => x.index === e.index);
    }

    toggleSelectAll = (e) => {
        this.isSelectAll = e.target.checked;
        this.selectedRows = e.target.checked ?
            this.data.map((item, i) => {
                return {
                    dataItem: item,
                    index: i + this.gridState.skip
                }
            }) : [];
        this.template.select(this.selectedRows);
    }


    /**
     * 
     */
    getColumnWidth = (column) => {
        let width = column.width;
        if (!column.width) return;
        return width;
    }


    /**
    * 
    */
    getControlColumnWidth = () => {
        let baseWidth = 24,
            width = 38;
        let ctrl = this.template.controls;
        if (ctrl.width) return ctrl.width;
        if (ctrl.edit) baseWidth += width;
        if (ctrl.delete) baseWidth += width;
        if (ctrl.customButtons) baseWidth += (ctrl.customButtons.length * width);
        return baseWidth;
    }

    isShowDetailTemplate = (dataItem: any, index: number): boolean => {
        return !!this.template.detailTemplate;
    }

    /**
     * Excel Export - Exports all columns with applied filters
     */
     allData = (): ExcelExportData => {
        console.log(this.fullDataSet);
        let data = this.fullDataSet;
        this.formatExcelSheetDates(data);
        if (!this.template.fileName) this.template.fileName = this.template.title;
        if (data.length > 0 && data[0] === undefined) data = [];
        
        this.cgpSnackbarService.showSnackbar({
          message: "Exporting " + data.length + " to Excel spreadsheet...",
          duration: 2000
        });

        return {
            data: process(data, {
                group: this.gridState.group,
                sort: this.gridState.sort,
                filter: this.gridState.filter
            }).data,
            group: this.gridState.group
        };
    }

    /**
     * Excel Export - Iterates through columns to find field names of type 'date'
     */
    formatExcelSheetDates = (data: any): any => {
        let dateColumns = [];
        if(this.template.columns){
            this.template.columns.forEach((column )=> {
                if(column.template?.type === 'date'){
                    dateColumns.push(column.field);
                }
            });
        }

        if(dateColumns){
            data.forEach(element => {
               dateColumns.forEach(date => {
                   element[date] = this.datePipe.transform(element[date],'MM-dd-yy');
               });
            });
        }
    }

}
